import request from '@/utils/request'
//search7000List
export function search7000List(param) {
    let data = param
    return request({
      url: `/v20/search7000List`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
}
//searchPlanList
export function searchPlanList(param) {
  return request({
    url: '/v20/searchPlanList',
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param
  })
}
//searchActualList
export function searchActualList(param) {
  return request({
    url: '/v20/searchActualList',
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param
  })
}

// searchPlanList_SUB
export function searchPlanList_SUB(param) {
  return request({
    url: '/v20/searchPlanList_SUB',
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param
  })
}

// searchActualList_SUB
export function searchActualList_SUB(param) {
  return request({
    url: '/v20/searchActualList_SUB',
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param
  })
}

//getShipNo
export function getShipNo(param) {
    let data = param
    return request({
      url: `/v20/getShipNo7`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
}  
//getTugBoat
// export function getTugBoat(param) {
//   let data = param
//   return request({
//     url: `/v20/getTugBoat7`,
//     method: 'POST',
//     meta: { apiVersion: '1.0.0' },
//     headers: { 'Content-Type': 'application/json;charset=utf8' },
//     data
//   })
// }  

//getDept
export function getDept(param) {
  let data = param
  return request({
    url: `/v20/getDept7`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}  

//getGroup
export function getGroup(param) {
  let data = param
  return request({
    url: `/v20/getGroup7`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}  

//getTeam
export function getTeam(param) {
  let data = param
  return request({
    url: `/v20/getTeam7`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}  

//getGunte
export function getGunte(param) {
  let data = param
  return request({
    url: `/v20/getGunte7`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}  


//getPlace
export function getPlace(param) {
  let data = param
  return request({
    url: `/v20/getPlace7`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}  

//getTotalTime
export function getTotalTime(param) {
  let data = param
  return request({
    url: `/v20/getTotalTime7`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}  

// getWorkActShip
export function getWorkActShip(param) {
  let data = param
  return request({
    url: '/v20/getWorkActShip',
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// getWorkActExShip
export function getWorkActExShip(param) {
  let data = param
  return request({
    url: '/v20/getWorkActExShip',
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// getWorkActIndirect
export function getWorkActIndirect(param) {
  let data = param
  return request({
    url: '/v20/getWorkActIndirect',
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//getPurpose
export function getPurpose(param) {
  let data = param
  return request({
    url: `/v20/getPurpose7`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
} 

//getEmpNo
export function getEmpNo(param) {
  let data = param
  return request({
    url: `/v20/getEmpNo7`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
} 

//getAlreadyConfirm
export function getAlreadyConfirm(param) {
  let data = param
  return request({
    url: `/v20/getAlreadyConfirm7`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
} 

// insertPlan
export function insertPlan(param) {
  let data = param
  console.log('insertPlan param', param)

  return request({
    url: `/v20/insertPlan`,
    meta: { apiVersion: '1.0.0' },
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data
  })
}

// updatePlan
export function updatePlan(param) {
  let data = param
  console.log('updatePlan param', param)

  return request({
    url: `/v20/updatePlan`,
    meta: { apiVersion: '1.0.0' },
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data
  })
}

// DELETE actual
export function deleteActual(param) {
  return request({
    url: '/v20/deleteActual',
    method: 'POST',
    data: param
  })
}

// DELETE plan
export function deletePlan(param) {
  return request({
    url: '/v20/deletePlan',
    method: 'POST',
    data: param
  })
}

// INSERT actual list
export function insertActual(list) {
  return request({
    url: '/v20/insertActual',
    method: 'POST',
    data: list
  })
}

// getSignStatus
export function getSignStatus(param) {
  let data = param
  return request({
    url: `/v20/getSignStatus7`,
    meta: { apiVersion: '1.0.0' },
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data
  })
}

// confirmSign
export function confirmSign(param) {
  let data = param
  // console.log('param', param)
  return request({
    url: `/v20/confirmSign7`,
    meta: { apiVersion: '1.0.0' },
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data
  })
}




 
